export default __webpack_public_path__ + "static/media/corner-out.39728bd8.svg";